module.exports = "<a href=\"${href}\"><span class=\"dijitInline material-icons csi-material-icon-${icon}\" data-dojo-attach-point=\"iconNode\"></span></a>"